import { render, staticRenderFns } from "./UserSwiper.vue?vue&type=template&id=4bcecb08&lang=pug&"
import script from "./UserSwiper.vue?vue&type=script&lang=js&"
export * from "./UserSwiper.vue?vue&type=script&lang=js&"
import style0 from "./UserSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports